// extracted by mini-css-extract-plugin
export default {"container":"OxygenImportantInfo_container__3udv1","badge":"OxygenImportantInfo_badge__4ExO6","icon":"OxygenImportantInfo_icon__sE0D6","content":"OxygenImportantInfo_content__ropvy"};